import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizedDateService, TimezoneTagToNameMap } from '@sondermind/utilities/time-and-date';

@Pipe({
  name: 'formatRequestedTimeSlot',
  standalone: true,
})
export class RequestedTimeSlotPipe implements PipeTransform {
  private readonly localizedDateService = inject(LocalizedDateService);

  transform(date: Date, timeZone: string, longMonth: boolean = false): string {
    if (date) {
      if (timeZone && TimezoneTagToNameMap[timeZone]) {
        // Format using LocalizedDateService with custom Intl.DateTimeFormatOptions
        const customFormat: Intl.DateTimeFormatOptions = {
          weekday: 'short',
          month: longMonth ? 'long' : 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
          timeZoneName: 'short',
          timeZone,
        };

        const formattedDate = this.localizedDateService.formatDate(date, {
          timezone: timeZone,
          customFormat,
        });

        // Insert " at " before the time portion
        // Expected format: "Mon, Jan 1, 3:30 PM EST" -> "Mon, Jan 1, at 3:30 PM EST"
        return formattedDate.replace(/,\s+(\d+:\d+)/, ', at $1');
      }

      return 'Invalid timezone for date';
    }

    // Invalid date
    return '';
  }
}
